import UserSettingsModule from '@/domains/UserCompany/User/Settings/UserSettingsModule';
import UserAccountModule from './UserAccount/UserAccountModule';
import LegalDocsModule from '../LegalDocs';
import * as CitiesModule from './Cities/CitiesModule';

const SETUP_INIT_STATE = {};

export default {
  namespaced: true,
  state: SETUP_INIT_STATE,
  modules: {
    UserAccount: UserAccountModule,
    LegalDocs: LegalDocsModule,
    UserSettings: UserSettingsModule,
    [CitiesModule.NAMESPACE]: CitiesModule.store,
  },
};
